import React from 'react';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import './LoginDetails.styles.scss';

const LoginDetails = ({ user }) => {
  const name = user?.displayName || 'Guest User';
  const email = user?.email || '—';

  return (
    <div className="login-details">
      <h2>
        <AccountCircleOutlinedIcon className="login-details__icon" />
        Login Details
      </h2>
      <div className="login-details__row">
        <span className="login-details__label">Name</span>
        <span className="login-details__value">{name}</span>
      </div>
      <div className="login-details__row">
        <EmailOutlinedIcon className="login-details__field-icon" />
        <span className="login-details__label">Email</span>
        <span className="login-details__value">{email}</span>
      </div>
    </div>
  );
};

export default LoginDetails;
